import { useCallback, useMemo } from "react";
import { useAppSelector } from "@/store/hooks";
import { RoleRules } from "@/security/roles";

/**
 * Acceso a permisos de accion segun el rol del usuario (`Role.rules`).
 * Independiente del gating por plan (ver `useFeatureAccess`).
 *
 * Misma semantica que PrivateRoute: default-deny, con bypass completo cuando el
 * tenant tiene `disabled_acl`. Las reglas las hidrata PrivateRoute en Redux antes
 * de montar cualquier pagina privada.
 */
const useRoleAccess = () => {
    const rulesRaw = useAppSelector((state) => state.user.userRoleData?.rules);
    const disabledAcl = useAppSelector((state) => state.suscription.suscription?.disabled_acl) || false;

    const rules = useMemo<RoleRules>(() => {
        if (!rulesRaw) return {};
        try {
            const parsed = typeof rulesRaw === "string" ? JSON.parse(rulesRaw) : rulesRaw;
            return parsed && typeof parsed === "object" ? parsed as RoleRules : {};
        } catch {
            return {};
        }
    }, [rulesRaw]);

    const canDo = useCallback((actionId: string): boolean => {
        if (disabledAcl) return true;
        return rules[actionId] === true;
    }, [disabledAcl, rules]);

    return { canDo };
};

export default useRoleAccess;
